import * as T from 'three'
import type { Bed } from './beds'
import { addRecessedArchLibrary } from './recessed-arch-library-model'
import { cabinBookshelf } from './custom-layout'

/** Independent cabinet below the upper cabins; does not extend the upper divider. */
export function addCabinBookshelf(root: T.Group, bed: Bed) {
  const s = bed.builtInBookshelf ? cabinBookshelf(bed) : null
  if (!s) return
  if (bed.bookshelfStyle === 'recessed_arch') { addRecessedArchLibrary(root, bed, s); return }
  const cabinet = new T.Group()
  cabinet.name = 'built-in-bookshelf'
  cabinet.userData.measurementName = 'Built-in bookshelf'
  cabinet.userData.dimensionsInches = { width: s.w, depth: s.h, height: s.height }
  const t = .75, back = .25, base = 3
  function panel(name: string, x: number, y: number, z: number, w: number, h: number, d: number) {
    const part = new T.Mesh(new T.BoxGeometry(w/12, h/12, d/12), new T.MeshStandardMaterial({color:0xffffff,roughness:.72}))
    part.name = 'bookshelf-' + name
    part.userData.finishPart = 'frame'
    part.userData.boxInches = {x,y,z,w,h,d}
    part.position.set((s.x+x+w/2-bed.width/2)/12,(y+h/2)/12,(s.y+z+d/2-bed.depth/2)/12)
    part.castShadow = true
    part.receiveShadow = true
    cabinet.add(part)
  }
  panel('left',0,0,0,t,s.height,s.h)
  panel('right',s.w-t,0,0,t,s.height,s.h)
  panel('back',t,0,0,s.w-2*t,s.height,back)
  panel('plinth',t,0,s.h-2,s.w-2*t,base,t)
  panel('bottom',t,base,back,s.w-2*t,t,s.h-back)
  panel('top',t,s.height-t,back,s.w-2*t,t,s.h-back)
  const clear = (s.height-base-4*t)/3
  for (let i=1;i<=2;i++) panel('shelf-'+i,t,base+t+i*clear+(i-1)*t,back,s.w-2*t,t,s.h-back)
  root.add(cabinet)
}

